/**
 * StatBrick - Single Metric Display
 * 
 * Principle: One number + label = one insight
 * Icon hints at meaning instantly
 */

import React from 'react';
import './statbrick.css';

export default function StatBrick({ value, label, unit, icon }) {
  return (
    <div className="stat-brick">
      <div className="stat-brick__icon">{icon}</div>
      <div className="stat-brick__content">
        <div className="stat-brick__value">
          {typeof value === 'number' ? value.toFixed(1) : value}
          <span className="stat-brick__unit">{unit}</span>
        </div>
        <div className="stat-brick__label">{label}</div>
      </div>
    </div>
  );
}
